import PropTypes from "prop-types";
import SectionEyebrow from "@/components/site/SectionEyebrow";

export default function PageHeader({ eyebrow, title, lead, testId, children }) {
  return (
    <header data-testid={testId || "page-header"} className="wt-section pb-8 md:pb-10">
      <div className="wt-container">
        <div className="max-w-3xl">
          {eyebrow && <SectionEyebrow>{eyebrow}</SectionEyebrow>}
          <h1 className="wt-h1 mt-4">{title}</h1>
          {lead && <p className="wt-lead mt-5">{lead}</p>}
          {children && <div className="mt-6">{children}</div>}
        </div>
      </div>
    </header>
  );
}

PageHeader.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string.isRequired,
  lead: PropTypes.string,
  testId: PropTypes.string,
  children: PropTypes.node,
};
